import {TaskFormField} from '../../../../types';
import {
  convertDateTimeToDate,
  convertDateTimeToUTC
} from '../../../../../callsheet/helpers';
import {meetsVisibilityCriteria} from '../../base_task/questionnaire/helpers/meetsVisibilityCriteria';
import {
  TaskField,
  TaskFieldRequiredState,
  valueToEmployeeSatisfactionStatus
} from '../../../../../../constants/tasks';

type Value = Nullable<Date | string | string[]>;

const formatSentimentSliderValue = (value) => {
  return valueToEmployeeSatisfactionStatus[value];
};

const formatValue = (value: Value, question?: TaskFormField): string => {
  if (question && question.type === TaskField.SENTIMENT_SLIDER) {
    return formatSentimentSliderValue(value);
  }

  if (!value) {
    return '';
  }

  if (Array.isArray(value)) {
    return value.join(',');
  }

  if (value instanceof Date) {
    if (question && question.type === TaskField.DATE_TIME) {
      return convertDateTimeToUTC(value);
    } else {
      return convertDateTimeToDate(value);
    }
  }

  return value;
};

export const formatAnswers = (
    answers: Dictionary<Nullable<string | string[]>> = {},
    formFields: Nullable<TaskFormField[]>
) => {
  const result: Dictionary<string | number>[] = [];

  const filteredAnswers:Dictionary<Nullable<string | string[]>> =
  Object.keys(answers)
      .filter((key) => {
        const answer = formFields?.find(({id}) => {
          return id === Number(key);
        });
        if (answer) {
          return meetsVisibilityCriteria(
              answer.required, answer.conditions, answers
          );
        }
      })
      .reduce((answer, key) => {
        const numKey = Number(key);

        answer[numKey] = answers[numKey];
        return answer;
      }, {});

  Object.entries(filteredAnswers).forEach(([key, value]) => {
    const question = formFields?.find(({id}) => id.toString() === key);
    const formattedValue = formatValue(value, question);

    if (question?.required === TaskFieldRequiredState.OPTIONAL &&
      !formattedValue) return;

    const formattedAnswer = {
      formFieldId: Number(key),
      answer: formattedValue
    };

    result.push(formattedAnswer);
  });

  return {
    answers: result
  };
};
